<ng-container *ngIf="viewModel$ | async as viewModel">
  <div *ngIf="!viewModel.isEditMode" class="chip">
    <div class="mediaContainer">
      <ng-container *ngIf="viewModel.readModeAgent; else addAgentIcon">
        <i class="nameInitials">{{ viewModel.readModeAgent?.name?.[0] }}</i>
      </ng-container>
    </div>
    <ng-container *ngIf="viewModel.readModeAgent; else addAgentContainer">
      <div
        class="content clickable"
        (click)="
          store.dispatch(
            actions.agentNameClicked({ userId: viewModel.readModeAgent.id })
          )
        "
      >
        <span class="value">{{ viewModel.readModeAgent?.name }}</span>
        <span class="label">{{ role }}{{ viewModel.readModeAgent?.deletedAt ? ' (deleted)' : '' }}</span>
      </div>
      <p-button
        *ngIf="canEditAgent$ | async"
        size="small"
        class="chipActionsButton"
        icon="pi pi-ellipsis-v"
        [text]="true"
        (onClick)="menu.toggle($event)"
      ></p-button>
    </ng-container>
  </div>

  <div class="chip" *ngIf="viewModel.isEditMode">
    <div class="content">
      <p-autoComplete
        [ngModel]="viewModel.agent"
        [suggestions]="viewModel.employees"
        (completeMethod)="
          store.dispatch(
            actions.employeeAutocompleteSearchFired({
              query: $event.query,
              role: role,
            })
          )
        "
        (input)="
          store.dispatch(
            actions.employeeAutocompleteInputChanged({
              value: $event.target.value,
              role: role,
            })
          )
        "
        (onSelect)="
          store.dispatch(
            actions.employeeSelected({
              employee: $event.value,
              role: role,
            })
          )
        "
        [emptyMessage]="viewModel.emptyMessage"
        field="name"
        placeholder="Select agent..."
        appendTo="body"
        autofocus
        completeOnFocus="true"
        panelStyleClass="p-pt-0"
        [panelStyleClass]="classes.employeesPanel"
      >
        <ng-template pTemplate="header">
          <ul
            class="p-autocomplete-items"
            (click)="
              store.dispatch(actions.addMyselfButtonClicked({ role: role }))
            "
          >
            <li class="p-autocomplete-item">
              <span class="freya-link-button">+ Add Myself</span>
            </li>
          </ul>
        </ng-template>
      </p-autoComplete>
    </div>
  </div>

  <p-menu
    #menu
    [model]="actionMenuItems"
    [popup]="true"
    appendTo="body"
    [styleClass]="classes.menu"
  ></p-menu>

  <ng-template #addAgentIcon>
    <i class="pi pi-user"></i>
  </ng-template>
  <ng-template #addAgentContainer>
    <div
      class="content clickable"
      (click)="store.dispatch(actions.addAgentButtonClicked({ role: role }))"
    >
      <span class="addAgent">+ {{ role }}</span>
    </div>
  </ng-template>
</ng-container>
